import { render, staticRenderFns } from "./AskBlock.vue?vue&type=template&id=beaf1614&scoped=true"
import script from "./AskBlock.vue?vue&type=script&lang=js"
export * from "./AskBlock.vue?vue&type=script&lang=js"
import style0 from "./AskBlock.vue?vue&type=style&index=0&id=beaf1614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf1614",
  null
  
)

export default component.exports